import axios from "../../fetch-api/fetch-api";
import { IGetProductLoyaltyRewards } from "../interfaces/product-api.type";

export function getProductLoyaltyRewardsApi(skus: string[]) {
  return axios.get<IGetProductLoyaltyRewards>("s/get-products-loyalty-rewards", {
    params: {
      skus,
    },
  });
}

export default getProductLoyaltyRewardsApi;
